import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';
import A11yDialog from 'a11y-dialog';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock-upgrade';

function initMore(moreButton) {
  if (!moreButton) return;

  const dialogId = moreButton.dataset.caseDialog;
  if (!dialogId) return;

  const dialogElement = document.getElementById(dialogId);
  if (!dialogElement) return;

  const swiperElement = dialogElement.querySelector('.cases-dialog__swiper');

  let swiper;
  const dialog = new A11yDialog(dialogElement);
  dialog.on('show', () => {
    disableBodyScroll(dialogElement);
    if (swiperElement) {
      swiper = new Swiper(swiperElement, {
        modules: [Pagination],
        spaceBetween: 16,
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    }
  });

  dialog.on('hide', () => {
    enableBodyScroll(dialogElement);
    if (swiper) swiper.destroy();
  });

  moreButton.addEventListener('click', () => {
    dialog.show();
  });
}

function init(element) {
  const swiperElement = element.querySelector('.cases__swiper');
  const swiper = new Swiper(swiperElement, {
    modules: [Pagination],
    spaceBetween: 16,
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      1024: {
        enabled: false,
      },
    },
  });

  element.querySelectorAll('.cases__more').forEach((more) => initMore(more));
}

export function cases() {
  document.querySelectorAll('.cases').forEach((element) => init(element));
  initMore();
}
